export const ButtonTray = {
  baseStyle: {
    borderTop: 'solid 1px',
    borderTopColor: 'brand.lightgrey',
    margin: '0px 0px 48px 0px',
    paddingTop: '44px',
  },
  variants: {
    NotInPage: {
      border: '0px solid',
      borderTop: '0',
      borderTopColor: 'transparent',
      padding: '40px 0 0 0',
      margin: '0px auto 20px auto',
      maxWidth: '960px',
      textAlign: 'right',
    },
  },
};
